import 'leaflet-defaulticon-compatibility';
import VueI18n from 'vue-i18n';
import {ObserveVisibility} from 'vue-observe-visibility';
import {Vue} from 'vue-property-decorator';
import VueRouter from 'vue-router';
import './polyfills';

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.directive('observe-visibility', ObserveVisibility);

Vue.config.productionTip = false;

